import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '@bibliocommons/base-links';
import { checkedOutItemShape } from '@bibliocommons/bc-prop-types';

export class ThirdPartyReaderLink extends React.PureComponent {
  render() {
    const { checkoutItem, linkTag } = this.props;
    const LinkTag = linkTag || Link;

    return (
      <LinkTag
        target="_blank"
        href={checkoutItem.get('thirdPartyReaderUrl')}
        className="cp-third-party-reader-link"
        dataKey="third-party-reader-link"
      >
        <FormattedMessage id="open_in_third_party_reader" />
      </LinkTag>
    );
  }
}

ThirdPartyReaderLink.propTypes = {
  checkoutItem: checkedOutItemShape.isRequired,
  linkTag: PropTypes.func
};

export default ThirdPartyReaderLink;
